var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('docu-head'),_c('div',{staticClass:"wrapBox mainBox"},[_c('docu-menu',{on:{"search":_vm.search}}),(_vm.$route.query.docMenuId)?_c('docu-list',{ref:"child"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }